import { render } from "./leadSlider2.vue?vue&type=template&id=71e2a636&scoped=true"
import script from "./leadSlider2.vue?vue&type=script&lang=js"
export * from "./leadSlider2.vue?vue&type=script&lang=js"

import "./leadSlider2.vue?vue&type=style&index=0&id=71e2a636&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e2a636"]])

export default __exports__